import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import {
  privateDataActions,
  privateDataSelectors,
} from '_core/store/PrivateData'
import { withLang } from '_core/hocs/withLang'
import { withCatch } from '_core/hocs/withCatch'
import { ReferralLinkView } from './ReferralLinkView'

const mapState = state => ({
  visitorLinks: privateDataSelectors.getVisitorLink(state),
})

const mapDispatch = {
  updateVisitorLink: privateDataActions.updateVisitorLink,
}

const RawReferralLink = props => {
  const {
    visitorLinks,
    render,
    component: Component,
    langInfo,
    updateVisitorLink,
  } = props

  const {
    request: { queue },
    config: { API_METHOD },
  } = useGlobal()

  useEffect(() => {
    queue(API_METHOD.VISITOR_LINK, {})
      .then(updateVisitorLink);
  }, [langInfo])

  const childProps = {
    visitorLinks,
  }

  return render != null ? render(childProps) : <Component {...childProps} />
}

RawReferralLink.displayName = 'RawReferralLink'

RawReferralLink.defaultProps = {
  component: ReferralLinkView,
}

RawReferralLink.propTypes = {
  // self props
  render: PropTypes.func,
  component: PropTypes.elementType,

  // `redux-connect` HOC props
  visitorLinks: PropTypes.arrayOf(PropTypes.object),
  updateVisitorLink: PropTypes.func.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const ReferralLink = withCatch(
  withLang(connect(mapState, mapDispatch)(RawReferralLink))
)
